import React, { useState, useEffect, useRef } from "react"
import styled, { createGlobalStyle } from "styled-components"
import { Link } from "gatsby"
import "./nav2.css"

import app_store from "../images/app_store.png"
import black_logo_text from "../images/black_logo_text.png"
import white_logo_text from "../images/white_logo_text.png"

function NavV2() {
  const [openDrawer, toggleDrawer] = useState(false)
  const drawerRef = useRef(null)
  const [scroll, setScroll] = useState(0)

  const dropdownRef = useRef(null)
  const dropdownRef2 = useRef(null)
  const [isActive, setIsActive] = useState(false)
  const [isActive2, setIsActive2] = useState(false)
  const onClick = () => setIsActive(!isActive)
  const onClick2 = () => setIsActive2(!isActive2)

  useEffect(() => {
    /* Close the drawer when the user clicks outside of it */
    const closeDrawer = event => {
      if (drawerRef.current && drawerRef.current.contains(event.target)) {
        return
      }

      toggleDrawer(false)
    }

    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 20)
    })

    document.addEventListener("mousedown", closeDrawer)
    return () => document.removeEventListener("mousedown", closeDrawer)
  }, [])

  return (
    <Styles.Wrapper>
      <CSSReset />

      <Navbar.Wrapper scroll={scroll}>
        <HamburgerButton.Wrapper onClick={() => toggleDrawer(true)}>
          <HamburgerButton.Lines />
        </HamburgerButton.Wrapper>
        <a href="/">
          <Navbar.Logo
            src={scroll ? black_logo_text : white_logo_text}
            alt="Logo"
          />
        </a>

        <Navbar.Items ref={drawerRef} openDrawer={openDrawer}>
          {/* <Navbar.Link href="/terms-of-service">Terms</Navbar.Link> */}
          {/* <Navbar.Link href="/privacy-policy">Privacy</Navbar.Link> */}

          <Navbar.Item onClick={onClick2}>About</Navbar.Item>
          <Navbar.Item href="/own-a-vacation-home">Own</Navbar.Item>
          <Navbar.Item href="/alpha">Alpha</Navbar.Item>
          <nav
            ref={dropdownRef2}
            className={`menu ${isActive2 ? "active" : "inactive"}`}
          >
            <ul>
              <li>
                <a href="/support">Support</a>
              </li>
              {/* <li> */}
              {/*   <a href="/contact">Contact</a> */}
              {/* </li> */}
              <li>
                <a href="/android">Android</a>
              </li>
              <li>
                <a href="/terms-of-service">Terms of Service</a>
              </li>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
            </ul>
          </nav>
{/*           <Navbar.Item onClick={onClick}>Buy</Navbar.Item> */}
{/*           <nav */}
{/*             ref={dropdownRef} */}
{/*             className={`menu ${isActive ? "active" : "inactive"}`} */}
{/*           > */}
{/*             <ul> */}
{/*               <li> */}
{/*                 <a href="/messages">Messages</a> */}
{/*               </li> */}
{/*               <li> */}
{/*                 <a href="/trips">Trips</a> */}
{/*               </li> */}
{/*               <li> */}
{/*                 <a href="/saved">Saved</a> */}
{/*               </li> */}
{/*             </ul> */}
{/*           </nav> */}
{/*  */}
{/*           <Navbar.Item>Onboard A House</Navbar.Item> */}
        </Navbar.Items>
      </Navbar.Wrapper>
    </Styles.Wrapper>
  )
}

const Styles = {
  Wrapper: styled.main`
    position: fixed;
    width: 100%;
    height: 100px;
    padding: 0px 0;
    z-index: 100;
    transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
  `,
}

const Navbar = {
  Wrapper: styled.nav`
    max-height: 50px;
    background: ${({ scroll }) => (scroll ? "white" : "transparent")};

    // 40em == 640px
    @media only screen and (max-width: 35em) {
      max-height: 80px;
    }
  `,

  Logo: styled.img`
    max-width: 200px;
    cursor: pointer;
    padding: 0px 0px 0px 30px;
    
    margin-right: 30px;
    position: absolute;
    @media only screen and (max-width: 40em) {

    margin-top: -60px;
    margin-left: 12px;
    }
  `,
  Items: styled.ul`
    display: flex;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: flex-start;
    list-style: none;
    padding: 0px 0px 0px 300px;
    margin-top: 15px;
    margin-right: 30px;
    @media only screen and (max-width: 40em) {
      position: fixed;
      right: -30px;
      top: 0;

      height: 100%;

      flex-direction: column;

      background-color: white;
      padding: 1rem 2rem;

      transition: 0.2s ease-out;

      transform: ${({ openDrawer }) =>
        openDrawer ? `translateX(0)` : `translateX(100%)`};
    }
  `,

  Link: styled.a`
    cursor: pointer;
    padding: 8px 30px;
    margin: 8px 50px;
    font-size: 20px;
    border: none;
    font-weight: 350;
    border-radius: 10px;
    transition: 1s;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

    @media only screen and (max-width: 40em) {
      padding: 1rem 0;
    }
    &:hover {
      /*color: grey;*/
      /*shadow*/

      /*moves up*/
      /*transform:translateY(-3px);*/
    }
  `,

  Item: styled.a`
  color:black;
    cursor: pointer;
    padding: 8px 30px;
    margin: 8px 50px;
    font-size: 20px;
    border: none;
    font-weight: 700;
    border-radius: 10px;
    transition: 1s;
    background: ${({ scroll }) => (scroll ? "black" : "white")};

    @media only screen and (max-width: 40em) {
      padding: 1rem 0;
    }
    &:hover {
      color: grey;
      /*shadow*/
      /*box-shadow: 0 10px 20px rgba(0,0,0,0.25);*/
      /*moves up*/
      transform: translateY(-3px);
    }
  `,
}

const HamburgerButton = {
  Wrapper: styled.button`
    
    width: 3rem;
    position: relative;
    font-size: 12px;
    background: white;
    display: none;

    @media only screen and (max-width: 40em) {
      display: block;
      height: 10rem;
    }

    /* Remove default button styles */
    border: none;
    background: transparent;
    outline: none;

    cursor: pointer;

    &:after {
      content: "";
      display: block;
      position: absolute;
      height: 150%;
      width: 150%;
      top: -25%;
      left: -25%;
    }
  `,
  Lines: styled.div`
    top: 50%;
    margin-top: -0.125em;
    right: 0;

    &,
    &:after,
    &:before {
      /* Create lines */
      height: 2px;
      pointer-events: none;
      display: block;
      content: "";
      width: 100%;
      background-color: black;
      position: absolute;
    }

    &:after {
      /* Move bottom line below center line */
      top: -0.8rem;
    }

    &:before {
      /* Move top line on top of center line */
      top: 0.8rem;
    }
  `,
}

const CSSReset = createGlobalStyle`
  *,
  *::before, 
  *::after {
    margin: 0; 
    padding: 0;
    box-sizing: inherit;
  }

  html {
    font-size: 62.5%; /*1rem = 10px*/
    box-sizing: border-box;      
  }  

  body {
    font-size: 1.4rem;
    font-family: sans-serif;
  }
`

export default NavV2
